<template>
    <v-row justify="center" align="center" no-gutters>
        <v-col cols="12" xl="6" lg="6" md="8" sm="8">

            <v-row justify="center" no-gutters>
                <span class="text-h6 text-sm-h5 text-center">Finish Your Post</span>
            </v-row>


            <v-form v-model="isFormValid">
                <v-row justify="center" no-gutters class="mt-4">
                    <v-col cols="12" xl="8" lg="8" md="10" sm="10">

                        <v-row justify="center" no-gutters class="mb-4">
                            <v-col cols="12">
                                <v-row justify="center" no-gutters class="mb-2">
                                    <v-radio-group v-model="createPost.type" row dense mandatory hide-details label="Select Audience:" @change="checkPostType" class="mt-0 mb-2 mr-n4">
                                        <v-radio label="Public" value="public"></v-radio>
                                        <v-radio label="Group" value="group"></v-radio>
                                    </v-radio-group>
                                </v-row>

                                <v-row v-if="createPost.type == 'public'" justify="center" align="center" no-gutters class="mb-2">
                                    <span class="text-center font-weight-light text-subtitle-2 text-md-subtitle-1">*Your post will be available for everyone to see*</span>
                                </v-row>

                                <v-row v-if="createPost.type == 'group'" justify="center" align="center" no-gutters class="mb-2">

                                    <v-col cols="8" xl="6" lg="6" md="6" sm="6">
                                        <v-autocomplete v-model="createPost.group" :items="userGroups" dense item-text="groupName" item-value="groupId" persistent-hint hint="Select a group from your groups" return-object no-data-text="No Groups to Select"></v-autocomplete>  
                                    </v-col>

                                    <v-col cols="2" class="hidden-sm-and-up">
                                        <v-btn small depressed rounded color="primary" @click.stop="newGroupDialog = true">
                                            <v-icon>mdi-account-multiple-plus</v-icon>
                                        </v-btn>
                                    </v-col>
                                        
                                    <v-col cols="2" align="center" class="hidden-xs-only">
                                        <v-tooltip right>
                                            <template v-slot:activator="{ on }">
                                                <v-btn v-on="on" small fab raised top left @click.stop="newGroupDialog = true" rounded color="primary">
                                                    <v-icon>mdi-account-multiple-plus</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Create a New Group</span>
                                        </v-tooltip>
                                    </v-col>

                                    <NewGroup v-if="newGroupDialog" :dialog="newGroupDialog" @cancelNewGroup="newGroupDialog = false"/>

                                </v-row>
                            </v-col>
                        </v-row>

                        <v-text-field v-model="createPost.title" clearable required flat dense outlined :rules="titleRules" :counter="50" label="Enter Title (required)"></v-text-field>
                        <v-textarea v-model="createPost.description" flat outlined dense clearable required no-resize :counter="750" :rules="descriptionRules" label="Enter Description (required)"></v-textarea>
                        <v-text-field v-model="createPost.videoLanguageSelected" :rules="languageRules" outlined clearable required flat dense label="Enter the language spoken in the uploaded Video, Audio or Youtube URL"></v-text-field>
                        <v-file-input v-model="createPost.thumbnail" ref="imageFileInput" :rules="thumbnailRules" :show-size="true" accept="image/*" flat dense outlined prepend-icon="" single-line append-icon="mdi-camera" type="file" label="Click to upload a thumbnail (optional)" @change="setPreviewImage" @click:clear="blurFileInput"></v-file-input>

                        <!-- IMAGE PREVIEW -->
                        <v-row justify="center" no-gutters class="mb-2">
                            <!-- USER IMAGE -->
                            <v-col v-if="showPreviewImage" cols="10" xl="6" lg="6" md="8" sm="8" align="center" class="pt-0" style="position: relative;">
                                <v-icon class="red--text text--darken-1 mt-4 ml-n2" style="z-index: 1; position: absolute; top: 0; left:0;" @click="clearPreviewImage()">mdi-close-circle</v-icon>
                                <span class="text-caption text-center">Thumbnail Preview</span>
                                <transition enter-active-class="slideDown" leave-active-class="slideUp"  appear>
                                    <v-img class="rounded-lg border--primary" contain height="140" :src="previewImage">

                                    </v-img>
                                </transition>
                            </v-col>
                            <!-- AUTO GENERATED IMAGE && NO THUMBNAIL IMAGE -->
                            <v-col v-else-if="showAutoGeneratedImage" cols="10" xl="6" lg="6" md="8" sm="8" align="center" class="pt-0">
                                <span v-if="mediaSelectionStep.fileSelected && !isIOS && !audioOnly" class="text-caption text-center cursor--pointer" @click="loadRandomFrame()">Generated Thumbnail 
                                    <v-icon small color="primary">mdi-reload</v-icon>
                                </span>
                                <span v-else class="text-caption text-center">Generated Thumbnail</span>
                                <transition enter-active-class="slideDown" leave-active-class="slideUp" appear>
                                    <v-img crossorigin="anonymous" class="rounded-lg border--primary" contain height="140" ref="autoGeneratedImage" :src="autoGeneratedImage"></v-img>
                                </transition>
                            </v-col>

                        </v-row>

                        <v-text-field v-model="tag" flat dense outlined counter="15" label="Enter Tags (optional)" :rules="tagRules" @keypress.enter="addTag" @keypress.space="addTag"></v-text-field>
                        <v-divider v-if="createPost.tags.length >= 1" class="my-1"/>
                        <span v-if="createPost.tags.length >= 1">Added Tags:</span><br/>
                        <v-row v-if="createPost.tags.length >= 1" class="ma-0 pa-0">
                            <v-col cols="12">
                                <v-chip close pill v-for="(tag) in createPost.tags" :key="tag" color="primary" @click:close="removeChip(tag)" class="mx-1">{{ tag }}</v-chip>
                            </v-col>
                        </v-row>

                        <v-divider v-if="suggestedTags.length >= 1" class="my-1"/>
                        <span v-if="suggestedTags.length >= 1">Suggested Tags:</span><br/>
                        <v-row v-if="suggestedTags.length >= 1" class="ma-0 pa-0">
                            <v-col cols="12">
                                <v-chip close close-icon="mdi-plus"  v-for="(t, i) in suggestedTags" :key="i" color="primary"  @click:close="addSuggestedChip(t,i)" class="mx-1">{{ t }}</v-chip>
                            </v-col>
                        </v-row>
                        <!-- <v-divider class="my-2"/> -->
                        <!-- <v-chip close pill v-for="(tag) in createPost.tags" :key="tag" color="primary" @click:close="removeChip(tag)" class="mx-1">{{ tag }}</v-chip> -->
                    </v-col>
                </v-row>
            </v-form>
        </v-col>
    </v-row>
</template>
<script>
import NewGroup from "../components/Groups/NewGroup.vue";
export default {
    name: 'PostContentMetadata',
    props: ["isDraftPost", "draftPost"],
    components: {
        NewGroup
    },
    data(){
        return {
            isFormValid: true,
            titleRules: [(v) => !!v || "Title is required", (v) => (v && v.length <= 50) || "Title must be 50 characters or less",],
            descriptionRules: [(v) => !!v || "Description is required", (v) => (v && v.length <= 750) || "Description must be 750 characters or less",],
            languageRules: [(v) => !!v || "Language Name is required", (v) => (v && v.length <= 50) || "Langugage name must be 30 characters or less",],
            tagRules: [(v) => (v.length <= 15) || "Tag must be 15 characters or less",],
            thumbnailRules: [
                (value) => !value ||
                value.size < this.thumbnailFileLimit ||
                "Thumbnail Must be less than 6 MB",
            ],
            thumbnailFileLimit: 6000000, // 6MB
            tag: "",
            suggestedTags: ["#tawq.in", "#translation", "#community",],
            // suggestedTags: [], // right now these are hard coded to come from this array, but can easily be updated to pull from somewhere else, or even the database.
            previewImage: null, // preview image is used to show any * USER SELECTED * files - can be cleared and will default back to an auto generated image
            showPreviewImage: false,
            showAutoGeneratedImage: true,
            autoGeneratedImage: null, // auto gen image is used to show all * AUTO GENERATED * images - cannot be cleared, can only be overwritten by a user selected image
            newGroupDialog: false,
            // RANDOM THUMBNAIL STUFF
            showThumbnailButton: false,
            thumbnailVideo: document.createElement("video"),
            audioOnly: false,
        }
    },
    methods: {
        checkPostType: function(type){
            this.createPost.type = type;
            if(type === 'public'){
                this.createPost.group = "";
                // this.createPost.groupLanguage = null;
            }
        },
        blurFileInput(){
            this.$refs.imageFileInput.blur();
        },
        clearPreviewImage(){ // this method is used to clear the preview image and go to the auto generated imaged.
            if (this.isDraftPost && (this.draftPost.thumbnail != null && this.draftPost.thumbnail != "") && this.draftPost.thumbnail == this.previewImage ) { // user has selected to remove the thumbnail associated with their draft post
                this.$emit('setDeleteDraftPostThumbnail', true); // set this value to true so during the save process we can delete what is stored in the database and upload the new thumbnail
                this.showPreviewImage = false;
                this.previewImage = null;
                this.createPost.thumbnail = null;
            } else {
                this.showPreviewImage = false;
                this.previewImage = null;
                this.createPost.thumbnail = null;
                this.setAutoGeneratedImage();
            }
        },
        readPreviewImage(){ // readPreviewImage() method is used to take the user selected image (of type file) and display it
            var reader = new FileReader();
            reader.onloadend = () => {
                this.previewImage = reader.result;
                reader = null;
            }
            reader.readAsDataURL(this.createPost.thumbnail);
        },
        setPreviewImage(){
            // determine whether it is a draft post or new post
            if (this.isDraftPost) {
                // if it is a draft post and has an image
                if (this.draftPost.thumbnail != null && this.draftPost.thumbnail != "") {
                    // draft post, and has an image associated with it already
                    // if there is no user selected image
                    if (typeof this.createPost.thumbnail == 'undefined' || this.createPost.thumbnail == null){
                        this.showPreviewImage = true;
                        this.previewImage = this.draftPost.thumbnail;
                        return;
                    }
                } else {
                    this.setAutoGeneratedImage();
                }
                return;
            }
            // determine if it is a youtube video or file upload
            if (this.mediaSelectionStep.youtubeUrlSelected) {
                // if a user has selected an image, preview it.
                if (typeof this.createPost.thumbnail != 'undefined' && this.createPost.thumbnail != null) {
                    this.readPreviewImage();
                    this.showPreviewImage = true;
                    this.showAutoGeneratedImage = false;
                    this.autoGeneratedImage = null;
                } else {
                    this.setAutoGeneratedImage();
                }

            } else if (this.mediaSelectionStep.fileSelected){
                // if a user has selected a file to upload, preview it
                if(typeof this.createPost.thumbnail != 'undefined' && this.createPost.thumbnail != null){
                    this.readPreviewImage();
                    this.showPreviewImage = true;
                    this.showAutoGeneratedImage = false;
                    this.autoGeneratedImage = null;
                } else {
                    // else auto generate one
                    this.setAutoGeneratedImage();
                }
            }
        },
        async setAutoGeneratedImage(){
            // this method will be ran when the user hasn't selected an image to be used with their post and we need to auto generate one, and anytime that the file input is cleared.
            this.showPreviewImage = false;
            this.previewImage = null;
            if (this.autoGeneratedImage != null) { // we have already generated the auto generated image. therefore just return!
                if(this.mediaSelectionStep.fileSelected){ // if it is a file upload though we just need to redraw the canvas...
                    this.loadRandomFrame();
                }
                this.showAutoGeneratedImage = true;
                return;
            }
            if (!this.mediaSelectionStep.complete) {
                // Check if there has been a video (we may have this step as the first step again....)
                this.showAutoGeneratedImage = true;
                this.autoGeneratedImage = require('../assets/no-thumbnail.png');
                return;
            } else if (this.mediaSelectionStep.complete && this.mediaSelectionStep.youtubeUrlSelected) {
                // if there is a video : if youtube show the thumbnail with the youtube video. if it is a file upload, randomly select a frame to begin with
                this.autoGeneratedImage = this.getYoutubeThumbnail();
                this.showAutoGeneratedImage = true;
                return;
            } else if (this.mediaSelectionStep.complete && this.mediaSelectionStep.fileSelected) {
                if(this.isIOS && !this.audioOnly){  // if the user is using an ios device context.drawImage() doesn't work
                    this.autoGeneratedImage = require('../assets/no-thumbnail.png');
                    this.showAutoGeneratedImage = true;
                }  else {
                    // file selected in auto generate image, and not an IOS Device. loading a random one!
                    // generate a random thumbnail from the video selected.
                    if (this.createPost.video.type.split("/")[0] === "video"){
                        this.loadRandomFrame();
                        this.showAutoGeneratedImage = true;
                        return;
                    } else {
                        this.autoGeneratedImage = require('../assets/audio-only.jpeg');
                        this.showAutoGeneratedImage = true;
                        return;
                    }
                }
            }
        },
        loadRandomFrame: function () {
            if(!isNaN(this.thumbnailVideo.duration)) {
                var rand = Math.round(Math.random() * this.thumbnailVideo.duration * 1000) + 1;
                this.thumbnailVideo.currentTime = rand / 1000; // this will "seek" the video and call generateRandomThumbnailFromVideo()
            }
        },
        generateRandomThumbnailFromVideo(){
            return new Promise((resolve) => {
                let canvas = document.createElement("canvas");
                let context = canvas.getContext('2d');
                let videoHeight = this.thumbnailVideo.videoHeight;
                let videoWidth = this.thumbnailVideo.videoWidth;
                canvas.width = videoWidth;
                canvas.height = videoHeight;
                
                context.drawImage(this.thumbnailVideo, 0, 0, videoWidth, videoHeight);
                this.autoGeneratedImage = canvas.toDataURL(); // this sets the auto generated image preview
                // below will create a file of the random image in the case that the user decides to use the random image to upload with their post
                context.canvas.toBlob((blob) => {
                    // this.autoGeneratedImage = blob;
                    this.createPost.thumbnail = new File([blob], "rand_thumbnail", {
                        type: 'image/jpeg',
                        lastModified: Date.now()
                    });
                    resolve();
                }, 'image/jpeg', 1);
            });
        },
        getYoutubeThumbnail(){
            if (this.mediaSelectionStep.youtubeUrlSelected) {
                if (typeof this.createPost.videoUrl.split('v=')[1] != 'undefined') {
                    const videoId = this.createPost.videoUrl.split('v=')[1].split('&ab_channel')[0];
                    const youtube_static_url = `https://img.youtube.com/vi/${videoId}/mqdefault.jpg`;
                    return youtube_static_url;
                } else if (typeof this.createPost.videoUrl.split('be/')[1] != 'undefined') {
                    const videoId = this.createPost.videoUrl.split('be/')[1];
                    const youtube_static_url = `https://img.youtube.com/vi/${videoId}/mqdefault.jpg`;
                    return youtube_static_url;
                } else if (typeof this.createPost.videoUrl.split('embed/')[1] != 'undefined') {
                    const videoId = this.createPost.videoUrl.split('embed/')[1];
                    const youtube_static_url = `https://img.youtube.com/vi/${videoId}/mqdefault.jpg`;
                    return youtube_static_url;
                } else {
                    return require('../assets/no-thumbnail.png');
                }
            } else {
                return require('../assets/no-thumbnail.png');
            }
        },
        addTag: function () {
            if(this.tag != "" && this.tag.length <= 15 && !this.createPost.tags.includes("#" + this.tag) && this.createPost.tags.length < 9) {
                if(this.tag.startsWith(" ")){
                    this.tag = this.tag.split(" ")[1];
                }
                if(this.tag.startsWith("#")){
                    this.createPost.tags.push(this.tag);
                } 
                else {
                    this.createPost.tags.push("#" + this.tag);
                }
                this.tag = "";
            }
        },
        addSuggestedChip: function (tag, index) {
            if (!this.createPost.tags.includes(tag) && this.createPost.tags.length < 9) {
                this.createPost.tags.push(tag);
                this.suggestedTags.splice(index, 1);
            } else if (this.createPost.tags.includes(tag) && !this.createPost.tags.length < 9) {
                this.suggestedTags.splice(index, 1);
            } // else do nothing
        },
        removeChip: function (tag) {
            this.createPost.tags.splice(this.createPost.tags.indexOf(tag), 1);
        },
    },
    watch:{
        isFormValid(newValue){
            if(newValue){
                this.$store.commit('newPost/saveContentMetadataStep', { complete: true });
            }
            else {
                this.$store.commit('newPost/saveContentMetadataStep', { complete: false });
            }
        }
    },
    computed: {
        createPost: {
            get(){
                return this.$store.state.newPost.createPost
            },
            set(value){
                this.$store.commit('newPost/saveCreatePost', value);
            }
        },
        mediaSelectionStep(){
            return this.$store.state.newPost.mediaSelectionStep;
        },
        userGroups(){
            return this.$store.state.userGroups;
        },
        isIOS(){
            return this.$store.state.isIOSDevice;
        },
    },
    beforeDestroy(){
        this.$store.commit('newPost/saveContentMetadataStep', { complete: true });
        this.thumbnailVideo.removeEventListener("seeked", this.generateRandomThumbnailFromVideo);
    },
    mounted: function(){
        if(this.isDraftPost && this.isFormValid){
            this.$store.commit('newPost/saveContentMetadataStep', { complete: true });
        }
    },
    created: function() {
        if (this.mediaSelectionStep.fileSelected) {
            if (this.createPost.transcoded) {
                if (this.createPost.thumbnail === null || this.createPost.thumbnail === "" || typeof this.createPost.thumbnail === 'undefined') {
                    // It has been transcoded but does not have a thumbnail selected. We can't generate a random one so set to default no-thumbnail.png
                    this.thumbnailVideo.crossOrigin = 'anonymous';
                    this.thumbnailVideo.src = this.createPost.videoUrl;
                    this.thumbnailVideo.addEventListener('loadedmetadata', () => {
                        this.setPreviewImage();
                        this.thumbnailVideo.addEventListener("seeked", this.generateRandomThumbnailFromVideo);
                    });
                }
            } else {
                // Using a video file. Prep to showAutoGeneratedImage
                let type = this.createPost.video.type.split("/")[0];
                if (type === "video") {
                    this.thumbnailVideo.src = URL.createObjectURL(this.createPost.video);
                    this.thumbnailVideo.addEventListener('loadedmetadata', () => {
                        this.setPreviewImage();
                        this.thumbnailVideo.addEventListener("seeked", this.generateRandomThumbnailFromVideo);
                    });
                } else {
                    this.createPost.thumbnail = null
                    this.audioOnly = true;
                    this.autoGeneratedImage = require('../assets/audio-only.jpeg');
                }
            }
        } else {
            this.setPreviewImage();
        }
    }
}
</script>